import { render } from "./contactUsButton.vue?vue&type=template&id=a0fcb1d4&scoped=true&ts=true"
import script from "./contactUsButton.vue?vue&type=script&lang=ts"
export * from "./contactUsButton.vue?vue&type=script&lang=ts"

import "./contactUsButton.vue?vue&type=style&index=0&id=a0fcb1d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0fcb1d4"]])

export default __exports__